<img [ngSrc]="image|fileurl" width="80" height="100" alt="product" />
<div class="content">
  <div class="title">
    <a
      class="name"
      [routerLink]="['/product',item.product.no]"
      [queryParams]="{attr_ids:item.product_attr_value_ids,priced_attr_id:item.product_priced_attr_value_id}"
      >{{item.product.name}}</a
    >
    <app-price [price]="priced_attr?.value?.price??0"></app-price>
  </div>
  <div class="bottom">
    <div class="attrs">
      @for (attr_value of attrs; track $index) {
      <div class="attr">
        <span>{{attr_value.attr.name}}:</span>
        <span>{{attr_value.value.name}}</span>
      </div>
      }
      <div class="attr">
        <span>{{priced_attr?.attr?.name}}:</span>
        <span>{{priced_attr?.value?.name}}</span>
      </div>
    </div>
    <div class="quantity">
      <nz-input-number
        [(ngModel)]="quantity"
        [nzMin]="1"
        [nzStep]="1"
        [nzPrecision]="0"
        (ngModelChange)="onQuantityChanged()"
      />
      <a (click)="remove()">Remove</a>
    </div>
  </div>
</div>

@if (loading) {
<div class="loading" @fade>
  <mat-spinner [diameter]="40"></mat-spinner>
</div>
}
